module.exports = __webpack_public_path__ + "static/Slider9-604e4df6d9d545cee004d5a7d3ad5245.jpg";